export const REFRESH_TOKEN_KEY = `NGX-SRIMS-AUTH_REFRESH_TOKEN`;
export const ACCESS_TOKEN_KEY = `NGX-SRIMS-AUTH_ACCESS_TOKEN`;
export const ORDS_ACCESS_TOKEN_KEY = `NGX-SRIMS-ORDS_ACCESS_TOKEN`;
export const LAST_URL = `NGX-SRIMS-LAST_URL`;
export const UI_STATE = 'NGX-SRIMS-UI_STATE';
